import { ComponentType } from "react";
import {
  Route,
  Redirect,
  RouteProps,
  RouteComponentProps,
} from "react-router-dom";

interface User {
  "custom:region"?: string;
  "custom:administrator"?: string;
  "custom:external"?: string;
  "custom:usercompany"?: string;
}

interface NAMRouteExtraProps {
  isAuthenticated: boolean;
  user?: User;
}

interface NAMRouteProps<P> extends RouteProps {
  component: ComponentType<P>;
  props: P & NAMRouteExtraProps;
}

const isNAMUser = (user?: User): boolean => user?.["custom:region"] === "NAM";
const isInternalUser = (user?: User): boolean =>
  user?.["custom:external"] !== "true";
const isAdminUser = (user?: User): boolean =>
  user?.["custom:administrator"] === "true";

const NAMRoute = <P extends {}>({
  component: C,
  props: cProps,
  ...rest
}: NAMRouteProps<P>) => (
  <Route
    {...rest}
    render={(routeProps: RouteComponentProps) =>
      cProps.isAuthenticated &&
      ((isNAMUser(cProps.user) && isInternalUser(cProps.user)) ||
        isAdminUser(cProps.user)) ? (
        <C {...routeProps} {...cProps} />
      ) : (
        <Redirect
          to={{
            pathname: "/dashboard",
            state: {
              from:
                routeProps.location.pathname +
                (routeProps.location.search ? routeProps.location.search : ""),
            },
          }}
        />
      )
    }
  />
);

export default NAMRoute;
